import { VIEWPORT_TO_ROOT_MARGIN_MAP } from "./constants";

export const getFilterOverlayVisible = state =>
  state.layout.isFilterOverlayVisible;
export const getViewportCategory = state => state.layout.viewportCategory;
export const getRootMargin = state =>
  VIEWPORT_TO_ROOT_MARGIN_MAP[getViewportCategory(state)];
export const getThreeLineLayout = state => state.layout.threeLineLayout;
